import React, {memo} from "react"
import {MANIFEST} from "@manifest/product-summary"
import {useTemplatedComponent} from "@next/templating"
import connect from "./connect"

export interface PsImageContainer {
    templating: {mainTemplate: string; fallbackTemplate: string}
    children: JSX.Element
}

const PsImageContainer = memo(({templating, children}: PsImageContainer) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)

    return <ComponentName>{children}</ComponentName>
})
PsImageContainer.displayName = "PsImageContainer"

export default connect(PsImageContainer)
